import React, { useEffect, useState } from 'react';
import ApiProvider  from '../../../core/api/ApiProvider';
import Status from '../../../core/types/Status';


const PaymentCallbackDetails = () => {
  const [result, setResult] = useState<string>('');

  const loadPaymentInfo = async () => {
    // Trzeba dobrac sie do request.body ktore przychodzi od netsa
    const result = await ApiProvider.get<Status<{status: string}>>(`Payment/NetsCallBack`)
    setResult(result.data.status);
  }

  useEffect(() => {
    loadPaymentInfo();
  }, [])
  return (
    <>{result}</>
  );
};

export default PaymentCallbackDetails;
